// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-node_modules_jspdf_dist_jspdf_min_js":"2f80c1996b884c16","node_modules_jspdf-autotable_dist_jspdf_plugin_autotable_js":"12d4aa11c460173f"}[chunkId] + ".js";
};